import { h } from 'preact';
import { QuizAnnotation } from './quiz';
import { focusable } from 'utilities/accessibility';
import { expandable } from 'rendering/behaviors/expandable';
import { ControlBar } from 'rendering/components/adjacent_control_bar';
import { COMPOSITION_TYPES } from 'constants/annotations';

export class AdjacentQuizAnnotation extends QuizAnnotation {
    static scalable = false

    get rootAttrs() {
        const { expanded } = this.state;
        const { style, ...attrs } = super.rootAttrs;
        const { color = 'gray' } = this.getElementStyles(COMPOSITION_TYPES.QUIZ.QUESTION_TITLE);

        style.width = '100%';
        style.height = '100%';
        style.left = '0%';
        style.top = '0%';
        style.bottom = '0%';
        style.right = '0%'; 
        style.border = `1px solid ${color}`;

        return {
            ...attrs,
            style
        }
    }
}